// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, first, map, mergeMap, switchMap } from 'rxjs/operators';

import { OutletSearchService } from 'src/app/api/owcc/services';
import { selectApiContext } from 'src/app/select-api-context';
import { OwccAppState } from 'src/app/store/app.state';
import { EffectsBase } from 'src/app/store/effects-base';
import { runtimeVariablesUpdate } from 'src/app/store/runtime-variables/runtime-variables.actions';
import { filterTruthy } from 'src/app/utils/functions/rx-filters';
import { Outlet as LegacyOutlet } from 'src/app/utils/models/outlet.interface';

import { dealerLocatorFinishLoadAction, dealerLocatorStartLoadAction } from './dealer-locator.actions';

@Injectable()
export class DealerLocatorEffects extends EffectsBase {
  public loadDealer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dealerLocatorStartLoadAction, runtimeVariablesUpdate),
      concatLatestFrom(() => this.store),
      filter(([action, storeState]) => {
        if (!action.payload.outletId) {
          return false;
        }
        if (!(storeState as OwccAppState).mbcc.outlets) {
          return true;
        }

        // Checks if outlet is already loaded.
        const outletLoaded = (storeState as OwccAppState).mbcc.outlets.find(
          outlet => outlet.outletId === action.payload.outletId
        );
        return !outletLoaded;
      }),
      mergeMap(([action]) =>
        this.store.select(selectApiContext).pipe(
          filterTruthy(),
          first(),
          switchMap(({ market, subProcess }) =>
            this.outletService.findOutlet({
              market,
              subProcess,
              outletId: action.payload.outletId as string
            })
          )
        )
      ),
      map(outlet => dealerLocatorFinishLoadAction({ payload: { outlet: outlet as LegacyOutlet } }))
    )
  );

  public constructor(
    private readonly store: Store,
    private readonly outletService: OutletSearchService
  ) {
    super();
  }
}
